export enum DialogEventEnum {
  open = 'open',
  close = 'close',
  save = 'save',
  delete = 'delete',
  create = 'create'
}
